angular
  .module('contrast.services.user', [])
  .factory(
    'UserService',
    function (
      $rootScope,
      pendoService,
      ProfileService,
      TS_BASE_URL,
      ACCESS_EVENTS
    ) {
      return {
        createImportUser: function (user) {
          var form = {
            api_only: user.api_only,
            enabled: user.enabled,
            username: user.username,
            role: user.role,
            groups: []
          }

          var groups = []
          _.each(user.groups, function (group) {
            groups.push(group.group_id)
          })
          form.groups = groups

          return form
        },
        getCurrentOrganization: function () {
          var self = this
          return self.default_organization
        },
        getCurrentOrganizationId: function () {
          var self = this
          return self.default_organization.organization_uuid
        },
        isOrganizationProtectionEnabled: function () {
          var self = this
          return (
            (self.default_organization !== undefined &&
              self.default_organization.protection_enabled) ||
            false
          )
        },
        isEnterprise: function () {
          var self = this
          return self.enterprise
        },
        isLoaded: function () {
          var self = this
          return self.loaded
        },
        setCurrentOrganization: function (org, options) {
          if (!angular.isObject(options)) {
            options = {}
          }
          if (angular.isUndefined(options.broadcast)) {
            options.broadcast = true
          }

          if (
            angular.isDefined(this.default_organization) &&
            this.default_organization.apps_onboarded !== org.apps_onboarded
          ) {
            pendoService.initialize(ProfileService.getUser(), org)
          }

          this.default_organization = org
          this.loaded = true
          $rootScope.default_organization = org
          if (options.broadcast) {
            $rootScope.$broadcast(ACCESS_EVENTS.ACCESS_RELOAD, {})
          }
        },
        setEnterprise: function (enterprise) {
          var self = this
          self.enterprise = enterprise
        },
        buildUrl: function (path) {
          var self = this
          return '/' + self.getCurrentOrganizationId() + path
        },
        buildAPIUrl: function (postfix) {
          var self = this
          return TS_BASE_URL + '/' + self.getCurrentOrganizationId() + postfix
        },
        buildAPIOrgUrl: function (postfix) {
          var self = this
          return (
            TS_BASE_URL +
            '/organizations/' +
            self.getCurrentOrganizationId() +
            postfix
          )
        },
        showMenu: function (isAdmin) {
          var minOrgs = isAdmin ? 0 : 1
          return (
            !angular.isUndefined($rootScope.allowed_organizations) &&
            $rootScope.allowed_organizations.length > minOrgs
          )
        },
        setTsvRequired: function (required) {
          this.tsvRequired = required
        },
        getTsvRequired: function () {
          return angular.isUndefined(this.tsvRequired) ? true : this.tsvRequired
        },
        isFreemiumOrganization: function () {
          var self = this
          return angular.isDefined(self.default_organization)
            ? self.default_organization.freemium
            : false
        },
        getSampleApplicationID: function () {
          var self = this
          return angular.isDefined(self.default_organization)
            ? self.default_organization.sample_application_id
            : undefined
        },
        getSampleServerID: function () {
          var self = this
          return angular.isDefined(self.default_organization)
            ? self.default_organization.sample_server_id
            : undefined
        },
        setUserPreferences: function (setupSteps) {
          var self = this
          self.setupSteps = setupSteps
        },
        createOnboardingTutorialItem: function (tutorialKey) {
          var self = this
          return {
            key: tutorialKey,
            orgUuid: self.getCurrentOrganizationId(),
            isVisible: self.isFreemiumOrganization(),
            appId: self.getSampleApplicationID()
          }
        },
        getSetupSteps: function () {
          var self = this
          return self.setupSteps
        }
      }
    }
  )
